module.exports = ".center-text {\n  text-align: center; }\n\n.no-border-top {\n  border-top: 0px; }\n\n.z-index-0 {\n  z-index: 0 !important; }\n\n.table-border-bottom {\n  border-bottom: 1px solid #cfd8dc; }\n\n.button-border {\n  border: 1px solid black; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/catalogue/qa/qa-manage.component.scss
// module id = ./src/app/catalogue/qa/qa-manage.component.scss
// module chunks = main